// import React, { useState, useEffect } from "react";

// const images = [
//   "assets/img/slider/slider-1.jpg",
//   "assets/img/slider/slider-2.jpg",
// ];

// const Slider = () => {
//   const [current, setCurrent] = useState(0);
//   const length = images.length;

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrent((prev) => (prev + 1) % length);
//     }, 3000); // Slide every 3 seconds
//     return () => clearInterval(interval);
//   }, [length]);

//   const nextSlide = () => setCurrent((prev) => (prev + 1) % length);
//   const prevSlide = () => setCurrent((prev) => (prev - 1 + length) % length);

//   return (
//     <div className="slider">
//       <button className="prev" onClick={prevSlide}>
//         &#10094;
//       </button>
//       <button className="next" onClick={nextSlide}>
//         &#10095;
//       </button>
//       {images.map((img, index) => (
//         <div
//           className={index === current ? "slide active" : "slide"}
//           key={index}
//         >
//           {index === current && <img src={img} alt={`Slide ${index}`} />}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default Slider;

import React, { useState, useEffect } from "react";

const slides = [
  {
    image: "assets/img/slider/slider-1.jpg",
    title: "Reliable Elevator & Lift Solutions by Orient Elevators",
    subtitle:
      "Orient Elevators delivers safe, smart, and energy-efficient elevator and lift solutions designed for modern buildings with unmatched quality and reliability.",
  },
  {
    image: "assets/img/slider/slider-2.jpg",
    title: "Your Trusted Partner for Elevators, Escalators  Services",
    subtitle:
      "Experience comfort and safety with Orient Elevators – your trusted partner for elevator, escalator, and lift installation, repair, and maintenance services.",
  },
];

const Slider = () => {
  const [current, setCurrent] = useState(0);
  const length = slides.length;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % length);
    }, 6000); // Change slide every 5 seconds (slower)
    return () => clearInterval(interval);
  }, [length]);

  const nextSlide = () => setCurrent((prev) => (prev + 1) % length);
  const prevSlide = () => setCurrent((prev) => (prev - 1 + length) % length);

  return (
    <div className="slider">
      <button className="prev" onClick={prevSlide}>
        &#10094;
      </button>
      <button className="next" onClick={nextSlide}>
        &#10095;
      </button>

      {slides.map((slide, index) => (
        <div
          className={index === current ? "slide active" : "slide"}
          key={index}
        >
          {index === current && (
            <>
              <img src={slide.image} alt={`Slide ${index}`} />
              <div className="slide-text">
                <h2>{slide.title}</h2>
                <p>{slide.subtitle}</p>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default Slider;
